import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const REGIAO = import.meta.env.VITE_FUNCTIONS_REGION ?? "southamerica-east1";

/** Domínios do Workspace autorizados. Espelha firestore.rules e functions/src/config.ts. */
export const DOMINIOS_PERMITIDOS = (import.meta.env.VITE_ALLOWED_DOMAINS ?? "lonepine.com.br")
  .split(",")
  .map((d: string) => d.trim().toLowerCase())
  .filter(Boolean);

export const app = initializeApp(config);
export const auth = getAuth(app);
export const dbFs = getFirestore(app);
export const fns = getFunctions(app, REGIAO);

export const googleProvider = new GoogleAuthProvider();
// `hd` faz o Google já abrir a conta certa quando a pessoa tem várias. É conveniência,
// não trava: quem decide quem entra são as Rules e a callable aposLogin.
if (DOMINIOS_PERMITIDOS.length === 1) {
  googleProvider.setCustomParameters({ hd: DOMINIOS_PERMITIDOS[0]!, prompt: "select_account" });
} else {
  googleProvider.setCustomParameters({ prompt: "select_account" });
}

export function dominioPermitido(email: string | null | undefined): boolean {
  if (!email) return false;
  const dominio = email.toLowerCase().split("@")[1];
  return !!dominio && DOMINIOS_PERMITIDOS.includes(dominio);
}

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(dbFs, "127.0.0.1", 8080);
  connectFunctionsEmulator(fns, "127.0.0.1", 5001);
}
